import React from 'react';
import { FolderOpen } from 'lucide-react';
import './HeroSection.css';

interface SelectedProject {
  id: number;
  name: string;
}

interface MetricItem {
  value: number | string;
  label: string;
}

interface HeroSectionProps {
  loggedIn: boolean | undefined;
  displayName?: string;
  selectedProject?: SelectedProject | null;
  metrics?: MetricItem[];
}

function getGreeting(): string {
  const hour = new Date().getHours();

  if (hour < 12) {
    return 'Good morning';
  }

  if (hour < 18) {
    return 'Good afternoon';
  }

  return 'Good evening';
}

export default function HeroSection({
  loggedIn,
  displayName,
  selectedProject,
  metrics = [],
}: HeroSectionProps) {
  const greeting = getGreeting();

  return (
    <section className="landing-hero">
      <div className="landing-hero-content">
        <h1 className="landing-hero-title">
          {loggedIn && displayName
            ? `${greeting}, ${displayName}`
            : 'Welcome to the SRCNet'}
        </h1>

        <p className="landing-hero-subtitle">
          Enabling the discovery and collaborative analysis of SKA data - access your
          data, launch interactive sessions on high-performance compute facilities, and
          share your results with your collaborators.
        </p>

        {loggedIn && metrics.length > 0 && (
          <div className="landing-hero-metrics">
            {metrics.map((metric) => (
              <div key={metric.label} className="landing-hero-metric">
                <span className="landing-hero-metric-value">{metric.value}</span>

                <span className="landing-hero-metric-label">{metric.label}</span>
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
